@if (!isReadOnly) {
  <div>
    <div class="form-group">
      <label class="text-gray-dark">{{ title | translate }}</label>
      <div class="input-group">
        <input
          title="calendar"
          [disabled]="disabled"
          container="body"
          [minDate]="getMinDate()"
          [maxDate]="getMaxDate()"
          [markDisabled]="markDisabled"
          type="text"
          (paste)="onPaste($event)"
          (dragover)="onDragOver($event)"
          (keypress)="onKeyPress($event)"
          class="form-control input-with-append"
          [placeholder]="localeSettings.placeholder"
          name="dp"
          [ngClass]="{ 'input-error': validationErrors.length > 0 }"
          [(ngModel)]="ngbDateValue"
          ngbDatepicker
          #d="ngbDatepicker"
          (dateSelect)="onDateSelection($event)"
          (focusout)="focusOut()"
          autocomplete="off"
        />
        <div class="input-group-append">
          <button title="calendar" class="btn btn-input calendar" (click)="d.toggle()" type="button">
            <i-feather name="calendar" style="height: 10px; display: inherit"></i-feather>
          </button>
        </div>
      </div>
      @if (validationErrors.length > 0) {
        <div class="invalid-field">
          @for (error of validationErrors; track error) {
            <span> {{ error | translate }} <br /> </span>
          }
        </div>
      }
    </div>
  </div>
}

@if (isReadOnly) {
  <div>
    <div class="form-group read-only">
      <label class="text-gray-dark">{{ title | translate }}</label>
      @if (dateDisplay) {
        <div class="input-group">
          {{ dateDisplay | localdate: 'mediumDate' }}
        </div>
      }
      @if (!dateDisplay) {
        <div class="input-group">-</div>
      }
    </div>
  </div>
}
